import { Navigate, useParams } from "react-router-dom";

/** Temporary redirect from legacy `/join/:gameId` route during migration. */
const JoinGameRedirect = () => {
  const { gameId } = useParams<{ gameId: string }>();
  if (!gameId) {
    return <Navigate to="/" replace />;
  }
  return <Navigate to={`/game/${gameId}`} replace />;
};

export default JoinGameRedirect;
